export const NODE_ADDRESS_TEST = 'https://casperlabs-proxy-server.herokuapp.com/http://159.65.118.250:7777/rpc'
export const NODE_ADDRESS = 'https://casperlabs-proxy-server.herokuapp.com/http://94.130.141.117:7777/rpc';